export default __webpack_public_path__ + "static/media/unlock_offer_bag.aab79a3c.svg";